// Breakpoints
export const BREAKPOINT_DOWN_SMALL = "(max-width: 767px)";
export const BREAKPOINT_UP_MEDIUM = "(min-width: 1025px)";
export const BREAKPOINT_DOWN_MEDIUM = "(max-width: 1024px)";

export let BACKEND_ROOT;
export let FRONTEND_ROOT;

export const IS_PROD = ["production", "staging"].includes(process.env.ENV);

switch (process.env.ENV) {
  case "production":
    BACKEND_ROOT = "https://api.axios.com";
    FRONTEND_ROOT = "https://www.axios.com";
    break;
  case "staging":
    BACKEND_ROOT = "https://api-stage.axios.com";
    FRONTEND_ROOT = "https://firstorder-stage.axios.com";
    break;
  default:
    BACKEND_ROOT = "http://localhost:8000";
    FRONTEND_ROOT = "http://localhost:3006";
    break;
}

export const GRAPHQL_ROOT = IS_PROD ? `${BACKEND_ROOT}/graphql` : "http://localhost:8090/graphql";

export const API_ROOT = `${BACKEND_ROOT}/api/render/`;

export const EVENTS_API = "https://eventsdata.axios.com/upcoming-events.json";

// Draft js
export const BLOCK_TYPE = {
  EMBED: "embed",
  KEEP_READING: "keep-reading",
  QUOTE_ATTRIBUTION: "quote-attribution",
  STYLED_QUOTE: "styled-quote",
};

export const STYLE_TYPE = {
  BOLD: "bold",
  ITALIC: "italic",
};

export const ENTITY_TYPE = {
  LINK: "link",
};

export const STREAM_TYPE = {
  SECTION: "section",
  TAG: "tag",
  PERMALINK: "permalink",
  AUTHOR: "author",
};

export const TRACK_LAST_SEEN = [STREAM_TYPE.SECTION];

export const STREAM_TRACKING = {
  VIEWPORT_RATIO: 0.4, // minimum percentage of viewport taken up by a stream item to be a candidate for page view
  ELEMENT_RATIO: 1, // percentage of a stream item in viewport to be a candidate for page view
  TIMEOUT_LENGTH: 3000, // how long a stream item needs to be in the viewport before a page view is counted
};

// Enumerates these integers https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-networkStatus
export const APOLLO_NETWORK_STATUS = {
  LOADING: 1,
  SET_VARIABLES: 2,
  FETCH_MORE: 3,
  REFETCH: 4,
  POLL: 6,
  READY: 7,
  ERROR: 8,
};

export const DEFAULT_CARD_HEIGHT = {
  FULL_STORY_CARD: 500,
};

export const URL_ID_REGEXP = "([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|[0-9]+)";

// "Musical Meerkat" key - the default key's secret component was exposed to GitHub
export const RAVEN_DSN = "https://1b87f5b715e44d8496741fe423b7c3de@sentry.io/247977";

export const FACTS_MATTER_TEMPLATE = "00000000-0000-0000-0003-000000000001";

export const FB_JS_SDK_VERSION = "2.12";

export const SHARE_LINKS = [
  {
    NAME: "facebook",
    DESCRIPTION: "Share on Facebook",
    URL: "https://www.facebook.com/sharer/sharer.php",
    URL_PARAM: "u",
    ANALYTICS_PARAMS: {
      utm_source: "facebook",
      utm_medium: "fbsocialshare",
      utm_campaign: "organic",
    },
  },
  {
    NAME: "twitter",
    DESCRIPTION: "Share on Twitter",
    URL: "https://twitter.com/share",
    URL_PARAM: "url",
    ANALYTICS_PARAMS: {
      utm_source: "twitter",
      utm_medium: "twsocialshare",
      utm_campaign: "organic",
    },
    SOCIAL_PARAMS: { text: "" },
  },
  {
    NAME: "linkedin",
    DESCRIPTION: "Share on LinkedIn",
    URL: "https://www.linkedin.com/sharing/share-offsite",
    URL_PARAM: "url",
    ANALYTICS_PARAMS: {
      utm_source: "linkedin",
      utm_medium: "lisocialshare",
      utm_campaign: "organic",
    },
    SOCIAL_PARAMS: { mini: false },
  },
];

export const COPY_LINK =   {
  NAME: "link",
  DESCRIPTION: "Copy permalink to your clipboard",
};
